// extracted by mini-css-extract-plugin
export var bgImage = "sectionFeatureGeneric-module--bgImage--kDkcz";
export var columns = "sectionFeatureGeneric-module--columns--TetIN";
export var content = "sectionFeatureGeneric-module--content--3ruHo";
export var description = "sectionFeatureGeneric-module--description--aiFD5";
export var highlighted = "sectionFeatureGeneric-module--highlighted--jWp0g";
export var image = "sectionFeatureGeneric-module--image--pSBwF";
export var imageWrapper = "sectionFeatureGeneric-module--image-wrapper--pvyvL";
export var images = "sectionFeatureGeneric-module--images--M0S2H";
export var section = "sectionFeatureGeneric-module--section--lmNZd";
export var sectionWithNoMargine = "sectionFeatureGeneric-module--section-with-no-margine--VnhQV";
export var withBg = "sectionFeatureGeneric-module--with-bg--q2o81";
export var wrapper = "sectionFeatureGeneric-module--wrapper--sRXUi";